import styled from 'styled-components';

import { FONTS } from '../../../tokens/fonts';

export const PopupWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0,0,0,0.5);
    overflow: hidden;
    cursor: pointer;

    @media (max-width: 480px) {
      padding-top: 60px;
    }
`;

export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    overflow: auto;
    justify-content: space-between;
    flex-direction: column;
`;

export const Popup = styled.div`
    top: 4rem;
    position: relative;
    cursor: auto;
    display: block;
    min-width: 200px;
    border-radius: 4px;
    width: ${props => props.width ? props.width : 'auto'};
    height: ${props => props.height ? props.height : 'auto'};
    max-width: ${props => props.fullWidth ? '100%' : '95%'};
    background:${props => props.color ? props.color : '#fff'};
    animation: slideInBottom 0.4s;
    margin: auto;
    overflow: ${props => props.fullWidth ? 'auto' : 'initial'};
    @keyframes slideInBottom {
        0% {
          transform: translateY(-1000px);
          opacity: 0;
        }
        100% {
          transform: translateY(0);
          opacity: 1;
        }
      }
`;

export const Header = styled.div`
    position: relative;
    cursor: auto;
    display: flex;
    min-height: 100px;
    height: ${props => props.headerHeight ? props.headerHeight : 'auto'};
    border-radius: 4px 4px 0 0;
    background: ${props => props.headerBackground ? props.headerBackground : 'linear-gradient(88.39deg, #7E3FFF 0%, #FFAFF4 100%)'};
    margin: auto;
    padding-left: 60px;
    padding-right: 3rem;
    overflow: ${props => props.fullWidth ? 'auto' : 'initial'};
    ${FONTS.H2};
    color: #fff;
    align-content: center;

    @media (max-width: 480px) {
        ${FONTS.S};
        padding-left: 1.5rem;
        min-height: 60px;
    }
`;

export const ClosePopup = styled.div`
    position: absolute;
    width: 26px;
    height: 26px;
    background: 0 0;
    transform: rotate(45deg);
    transition: all .2s linear;
    z-index: 10;
    cursor: pointer;
    top: 15px;
    right: 15px;
    &::before {
        position: absolute;
        content: '';
        width: 2px;
        height: 24px;
        margin-top: -11px;
        left: 50%;
        top: 50%;
        background: ${props => props.color ? props.color : 'black'};
        transition: all .2s linear;
    }
    &::after {
        position: absolute;
        content: '';
        width: 24px;
        height: 2px;
        margin-left: -11px;
        left: 50%;
        top: 50%;
        background: ${props => props.color ? props.color : 'black'};
        transition: all .2s linear;
    }
`;
